module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};



//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/core-js/modules/_fails.js
// module id = 27
// module chunks = 168707334958949